import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const CustomTime = (props) => {
    const {
        label = "Select Time",
        value,
        onChange,
        name,
        disabled = false,
        fullWidth = true,
        required = false,
        error = false,
        helperText = '',
        size = "medium",
        sx = {},
        isLock,
        isReadOnly
    } = props;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                // label={label}
                value={value ? dayjs(value, "HH:mm") : null}
                onChange={(newValue) => {
                    if (onChange) {
                        const formattedTime = newValue ? dayjs(newValue).format("HH:mm") : '';
                        onChange({ target: { name, value: formattedTime } });
                    }
                }}
                disabled={disabled || isLock}
                readOnly={isReadOnly}
                slotProps={{
                    textField: {
                        fullWidth,
                        required,
                        error,
                        helperText,
                        size,
                        name,
                    },
                }}
                sx={{ ...sx, width: '100%' }}
            />
        </LocalizationProvider>
    );
};

export default CustomTime;
